<template>
  <div>
    <el-dialog
      :title="isEdit == 1 ? $t('lang.添加水价') : $t('lang.修改水价')"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
      :width="dialogWidth"
    >
      <el-form
        :model="priceForm"
        :rules="rules"
        ref="priceForm"
        label-width="110px"
        :hide-required-asterisk="true"
        :class="inputClass"
      >
        <el-form-item :label="$t('lang.水价名称')" prop="priceName">
          <el-input
            v-model="priceForm.priceName"
            :placeholder="$t('lang.请输入水价名称')"
          ></el-input>
        </el-form-item>
<!--        <el-form-item :label="$t('lang.水价类型')" prop="priceValue" class="form-select">-->
<!--          <el-select-->
<!--            v-model="priceForm.priceType"-->
<!--            :placeholder="$t('lang.请选择')"-->
<!--          >-->
<!--            <el-option-->
<!--              v-for="item in priceTypeList"-->
<!--              :key="item.value"-->
<!--              :label="item.label"-->
<!--              :value="item.value"-->
<!--            ></el-option>-->
<!--          </el-select>-->
<!--        </el-form-item>-->
        <el-form-item :label="$t('lang.单价')" prop="priceValue">
          <el-input
            v-model="priceForm.priceValue"
            type="number"
            :placeholder="$t('lang.请输入单价')"
          >
            <span slot="suffix">{{ monetary }}/m³</span>
          </el-input>
        </el-form-item>
        <el-form-item :label="$t('lang.备注')">
          <el-input
            v-model="priceForm.remarks"
            type="textarea"
            :placeholder="$t('lang.请输入备注')"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">{{ $t("lang.取消") }}</el-button>
        <el-button type="primary" @click="onClickSubmitted">{{
          $t("lang.确定")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import { mapActions } from "vuex";
  export default {
    components: {},
    data() {
      var priceVerification = (rule, value, callback) => {
        let regular = /^(0|[1-9]\d*)(\.\d{1,2})?$/;
        if (value == "") {
          callback(new Error(this.$t("lang.请输入水价金额")));
        } else if (!regular.test(value)) {
          callback(new Error(this.$t("lang.请输入最多两位小数的有效数字")));
        } else {
          callback();
        }
      };
      return {
        dialogVisible: false,
        isEdit: 1,
        priceTypeList:[
          { label:this.$t("lang.水价"), value:1},
          { label:this.$t("lang.热水价"), value:3},
        ],
        priceForm: {
          priceName: "",
          priceValue: "",
          priceType: 1,
          remarks: "",
        },
        rules: {
          priceName: [
            {
              required: true,
              message: this.$t("lang.请输入水价名称"),
              trigger: "blur",
            },
          ],
          priceValue: [
            {
              validator: priceVerification,
              trigger: "blur",
            },
          ],
        },
        monetary: "元",
      };
    },
    mounted() {},
    computed: {
      dialogWidth() {
        return this.$i18n.locale == "zh-CN" ? "569px" : "666px";
      },
      inputClass() {
        return this.$i18n.locale == "zh-CN" ? "width300" : "width400";
      },
    },
    methods: {
      ...mapActions({
        electricityPricesAdd: "ZD_ElectricityPricesAdd",
        electricityPricesUpdate: "ZD_ElectricityPricesUpdate",
      }),
      handleClose() {
        this.dialogVisible = false;
        this.$refs.priceForm.resetFields();
        this.priceForm.priceName = "";
        this.priceForm.priceValue = "";
        this.priceForm.remarks = "";
      },
      showDialog(type, item) {
        this.dialogVisible = true;
        this.isEdit = type;
        if (item) {
          this.priceForm = { ...item };
        }
        this.monetary = localStorage.getItem("monetary");
      },
      async onClickSubmitted() {
        try {
          await this.$refs.priceForm.validate();
          if (this.isEdit == 1) {
            let res = await this.electricityPricesAdd({ value: this.priceForm });
            if (res.success !== 1) return;
            this.$message({
              type: "success",
              message: this.$t("lang.添加成功"),
            });
          } else {
            let res = await this.electricityPricesUpdate({
              value: this.priceForm,
            });
            if (res.success !== 1) return;
            this.$message({
              type: "success",
              message: this.$t("lang.修改成功"),
            });
          }
          this.handleClose();
          this.$parent.getPriceList();
        } catch {}
      },
    },
  };
</script>

<style scoped lang='less'>
  // /deep/.el-dialog {
  //   width: 569px !important;
  // }
  .el-form {
    padding-left: 50px;
  }
  .width300 {
    .el-input {
      width: 300px;
    }
  }
  .width400 {
    .el-input {
      width: 400px;
    }
    /deep/ .el-textarea__inner {
      width: 400px;
    }
  }

  /deep/.el-dialog__body {
    padding-bottom: 10px;
    padding-top: 20px;
  }
  /deep/ .el-textarea__inner {
    width: 300px;
  }
  .form-select{
    /deep/.el-input{
      width: 300px;
    }
  }
</style>
